import mapboxgl from "mapbox-gl";
import {point, polygon} from "@turf/helpers";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon"

export const searchControlsByType = (map, controlTypeObject) => {
    let searchControls = [];
    if (map) {
        let controls = map._controls;
        controls.forEach(function (control) {
            if (control instanceof controlTypeObject) {
                searchControls.push(control)
            }
        })
    }

    return searchControls || null;
}

export const hasControlByType = (map, controlTypeObject) => {
    let controls = searchControlsByType(map, controlTypeObject)
    return (controls && !controls.length) || false;
}

/**
 * Set a fit MapView MapBox on Dockyard from bbox compute on API
 * @param dockyardData
 * @returns {*|null}
 */
export const fitToBoundsDockyard = dockyardData => {
    let bounds
    try {
        if (dockyardData && dockyardData.bbox) {
            let coordinates = dockyardData.bbox.coordinates[0];

            bounds = coordinates.reduce(function (bounds, coord) {
                return bounds.extend(coord);
            }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
        }
    } catch (e) {
        console.log(e)
    }
    return bounds || null
}

/**
 * Check which areas intersected by a point
 * @param dockyardAreaData
 * @param coordinatesToCheck
 * @returns {[]|*[]}
 */
export const checkPositionWithinPolygon = (dockyardAreaData, coordinatesToCheck) => {
    let polyAreaIntersects = []
    const pointData = point(coordinatesToCheck)
    try {
        dockyardAreaData.forEach(dockyardArea => {
            let poly = polygon(dockyardArea.geom.coordinates)
            let isWithin = booleanPointInPolygon(pointData, poly) || false
            isWithin && polyAreaIntersects.push(dockyardArea)
        })
    } catch (e) {
        console.log(e)
    }

    return polyAreaIntersects || []
}

export const getCurrentLocationUser = (map, mapContext) => {
    if (!navigator.geolocation) {
        console.log('No Geolocation available.')
    } else {
        navigator.geolocation.getCurrentPosition(position => {
            let userPosition = [position.coords.longitude, position.coords.latitude] || null
            if (userPosition) {
                mapContext.config.center = userPosition;
                map.setCenter(userPosition);
            }
        })
    }
}